module.exports = __webpack_public_path__ + "img/mew-hardware.ec0aa12a.png";